import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { assistantPropertiesApiToAssistantProperties, avatarVariantToAvatarVariantApi } from '../../entities/AssistantProperties/converters';
import { BaseClient } from '../BaseClient';
export class AssistantPropertiesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getMyAssistantProperties", void 0);
    _defineProperty(this, "createAssistantProperties", void 0);
    _defineProperty(this, "updateAssistantProperties", void 0);
  }
  async getProperties() {
    try {
      for (var _len = arguments.length, extraParam = new Array(_len), _key = 0; _key < _len; _key++) {
        extraParam[_key] = arguments[_key];
      }
      const {
        assistantProperties
      } = await this.request(this.getMyAssistantProperties({}), ...extraParam);
      return this.convertToEntity(assistantProperties);
    } catch (error) {
      this.logError('getProperties', 'Failed to get assistant properties', {}, error);
      throw error;
    }
  }
  async updateProperties(propertiesToUpdate) {
    try {
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        extraParam[_key2 - 1] = arguments[_key2];
      }
      const currentProperties = await this.getProperties(...extraParam);
      if (!currentProperties) {
        throw new Error('No assistant properties found');
      }
      const assistantProperties = await this.updatePropertiesFields({
        propertiesToUpdate,
        currentProperties
      }, ...extraParam);
      return this.convertToEntity(assistantProperties);
    } catch (error) {
      this.logError('updateProperties', 'Failed to update assistant properties', {
        propertiesToUpdate
      }, error);
      throw error;
    }
  }
  async createProperties(data) {
    try {
      for (var _len3 = arguments.length, extraParam = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        extraParam[_key3 - 1] = arguments[_key3];
      }
      const {
        assistantProperties
      } = await this.request(this.createAssistantProperties({
        assistantProperties: {
          name: data.name,
          imageUrl: data.imageUrl,
          avatarVariant: avatarVariantToAvatarVariantApi(data.avatarVariant),
          persona: {
            personality: data.personality,
            pronouns: data.pronouns,
            traits: data.traits
          }
        }
      }), ...extraParam);
      return this.convertToEntity(assistantProperties);
    } catch (error) {
      this.logError('createProperties', 'Failed to create assistant properties', {
        data
      }, error);
      throw error;
    }
  }
  convertToEntity(assistantProperties) {
    try {
      return assistantPropertiesApiToAssistantProperties(assistantProperties);
    } catch (error) {
      this.logError('convertToEntity', 'Invalid assistant properties data', {
        assistantProperties
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'AssistantPropertiesClient';
  }
  async updatePropertiesFields(_ref) {
    let {
      propertiesToUpdate,
      currentProperties
    } = _ref;
    const fieldMask = [];
    const existingProperties = {
      id: currentProperties.id,
      revision: currentProperties.revision,
      name: currentProperties.name,
      imageUrl: currentProperties.imageUrl,
      avatarVariant: avatarVariantToAvatarVariantApi(currentProperties.avatarVariant),
      persona: {
        personality: currentProperties.personality,
        pronouns: currentProperties.pronouns,
        traits: currentProperties.traits
      }
    };
    if (propertiesToUpdate.name) {
      fieldMask.push('name');
    }
    if (propertiesToUpdate.imageUrl) {
      fieldMask.push('imageUrl');
    }
    if (propertiesToUpdate.avatarVariant) {
      fieldMask.push('avatarVariant');
    }
    if (propertiesToUpdate.personality) {
      fieldMask.push('persona.personality');
    }
    if (propertiesToUpdate.pronouns) {
      fieldMask.push('persona.pronouns');
    }
    if (propertiesToUpdate.traits) {
      fieldMask.push('persona.traits');
    }
    if (!fieldMask.length) {
      return existingProperties;
    }
    for (var _len4 = arguments.length, extraParam = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      extraParam[_key4 - 1] = arguments[_key4];
    }
    const {
      assistantProperties
    } = await this.request(this.updateAssistantProperties({
      assistantProperties: {
        id: propertiesToUpdate.id,
        revision: propertiesToUpdate.revision,
        name: propertiesToUpdate.name,
        imageUrl: propertiesToUpdate.imageUrl,
        avatarVariant: avatarVariantToAvatarVariantApi(propertiesToUpdate.avatarVariant),
        persona: {
          personality: propertiesToUpdate.personality,
          pronouns: propertiesToUpdate.pronouns,
          traits: propertiesToUpdate.traits
        }
      },
      fieldMask
    }), ...extraParam);
    return assistantProperties;
  }
}
//# sourceMappingURL=AssistantPropertiesClientBase.js.map